import { c as _c } from "react/compiler-runtime";
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import type { IBreadcrumbItem } from '@/components/Molecules/Breadcrumb/Breadcrumb';
import { Breadcrumb } from '@/components/Molecules/Breadcrumb/Breadcrumb';
import { PageAction, PageActions } from '@/components/Molecules/PageActions/PageActions';
import { Byline } from '@/components/Organisms/PageHeader/PageHeader';
import classNames from '@/utils/classNames';
import type { FC, ReactNode } from 'react';
import styles from './ArticlePageHeader.module.css';
interface ArticlePageHeaderProps {
  /**
   * Use an empty array if this page is top level
   */
  breadCrumbs: IBreadcrumbItem[];
  /**
   * The main title
   */
  title: string;
  /**
   * ISO String. Used as a publication date to display
   */
  date?: string;
  /**
   * An optional byline name if a full author cannot be used
   */
  bylineName?: string;
  /**
   * Show the date/byline as UNPUBLISHED instead of the usual date
   */
  asUnpublished?: boolean;
  actions?: ReactNode[];
  prefix?: ReactNode;
  asBanner?: boolean;
  /**
   * Show a status pill for the page
   */
  status?: ReactNode;
}
export const ArticlePageHeader: FC<ArticlePageHeaderProps> = t0 => {
  const $ = _c(33);
  const {
    title,
    breadCrumbs,
    date,
    bylineName,
    prefix,
    status,
    asUnpublished,
    actions,
    asBanner: t1
  } = t0;
  const asBanner = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== asBanner) {
    t2 = asBanner ? {
      "data-cds-theme": "dark" as const
    } : {};
    $[0] = asBanner;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const themeProps = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(styles.header);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== breadCrumbs) {
    t4 = <Breadcrumb className={styles.breadcrumb} items={breadCrumbs} />;
    $[3] = breadCrumbs;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== status) {
    t5 = status && <div className={styles.status}>{status}</div>;
    $[5] = status;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== prefix) {
    t6 = prefix && <div className={classNames("cds-t-body-xlarge", styles.prefix)}>{prefix}</div>;
    $[7] = prefix;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== title) {
    t7 = <h1 className="cds-t-h1">{title}</h1>;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <CenteredPageContent className={styles.headerContent}>{t4}{t5}{t6}{t7}</CenteredPageContent>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8 || $[17] !== themeProps) {
    t9 = <header {...themeProps} className={t3}>{t8}</header>;
    $[16] = t8;
    $[17] = themeProps;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== actions || $[20] !== themeProps) {
    t10 = actions && actions.length > 0 && <PageActions {...themeProps}>{actions.map(_temp)}</PageActions>;
    $[19] = actions;
    $[20] = themeProps;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== asUnpublished || $[23] !== bylineName || $[24] !== date) {
    t11 = <Byline className={styles.byline} bylineName={bylineName} asUnpublished={asUnpublished} date={date} />;
    $[22] = asUnpublished;
    $[23] = bylineName;
    $[24] = date;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== themeProps) {
    t12 = <CenteredPageContent {...themeProps}>{t11}</CenteredPageContent>;
    $[26] = t11;
    $[27] = themeProps;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t9) {
    t13 = <>{t9}{t10}{t12}</>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};
function _temp(action, index) {
  return <PageAction key={index}>{action}</PageAction>;
}